import { IdTokenClaims } from 'oidc-client-ts';
import { useAuth } from 'react-oidc-context';

export type OidcUserProfile = IdTokenClaims & {
  sub: string;
  name: string;
  family_name: string;
  given_name: string;
  preferred_username: string;
  picture: string;
  locale: string;
  lang_code: string;
  occupation: string | null;
  shard_region: string;
  updated_at: number;
  account: string;
  email: string;
};

export function useOidcUserProfile(): OidcUserProfile | undefined {
  const auth = useAuth();
  const profile = auth?.user?.profile;

  // Convert null to undefined to match type definition
  return (profile as OidcUserProfile) ?? undefined;
}
